import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet, apiPost, apiPut } from "../../lib/axiosInstance";
import { logger } from "../../lib/utils";

export const fetchDevlogPage = createAsyncThunk("devlogs/fetchPage", async (page) => {
	const res = await apiGet(`/devlogs?page=${page}&limit=1`);
	return { devlogs: res.devlogs, page: res.page, totalPages: res.totalPages };
});

export const fetchDevlogBySlug = createAsyncThunk("devlogs/fetchBySlug", async (slug,{rejectWithValue}) => {
	try {
		const res = await apiGet(`/devlogs/slug/${slug}`);
		return res.devlog;
	} catch (error) {
		return rejectWithValue(error.response.data ? error.response.data.message : error.message);
	}
});

export const createNewDevlog = createAsyncThunk("devlogs/create", async (form) => {
	const res = await apiPost("/devlogs", form);
	return res.devlog;
});

export const updateDevlog = createAsyncThunk("devlogs/update", async ({ id, form }) => {
	const res = await apiPut(`/devlogs/${id}`, form);
	return res.devlog;
});
export const fetchSingleDevlog = createAsyncThunk("devlogs/fetchSingle", async (id) => {
	const res = await apiGet(`/devlogs/${id}`);
	return res.devlog;
});



export const fetchDevlogBatch = createAsyncThunk(
	"devlogs/fetchBatch",
	async ({ page, limit }) => {
		const res = await apiGet(`/devlogs?page=${page}&limit=${limit}`);
		return {
			devlogs: res.devlogs,
			page: res.page,
			totalPages: res.totalPages,
		};
	}
);
export const fetchMyDevlogs = createAsyncThunk(
	"devlogs/fetchMyDevlogs",
	async () => {
		const res = await apiGet(`/devlogs/user/me`);
		return res.devlogs;
	}
);

export const likeDevlog = createAsyncThunk(
	"devlogs/like",
	async (id, { rejectWithValue }) => {
		try {
			const res = await apiPost(`/devlogs/${id}/like`);
			return { id, likes: res.likes };
		} catch (error) {
			return rejectWithValue(
				error.response?.data?.message || error.message || "Failed to like devlog"
			);
		}
	}
);


const devlogSlice = createSlice({
	name: "devlogs",
	initialState: {
		items: [],
		myDevLogs:[],
		editingDevlog: null,
		devlog: null,
		page: 1,
		totalPages: 1,
		loading: false,
		error: null,
	},
	reducers: {
		resetDevlogs(state) {
			state.items = [];
			state.page = 1;
			state.totalPages = 1;
		},
		resetSingleDevlog(state) {
			state.devlog = null;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchMyDevlogs.pending, (state) => { state.loading = true; })
			.addCase(fetchMyDevlogs.fulfilled, (state, action) => {
				state.loading = false;
				state.myDevLogs = action.payload;
			})
			.addCase(fetchSingleDevlog.fulfilled, (state, action) => {
				logger.info("Fetched single devlog:", action.payload);
				state.editingDevlog = action.payload;
			})
			.addCase(fetchMyDevlogs.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
			})
			.addCase(fetchDevlogBatch.pending, (state) => { state.loading = true; })
			.addCase(fetchDevlogBatch.fulfilled, (state, action) => {
				state.loading = false;
				state.page = action.payload.page;
				state.totalPages = action.payload.totalPages;
				const ids = new Set(state.items.map(d => d._id));
				state.items.push(...action.payload.devlogs.filter(d => !ids.has(d._id)));
			})
			.addCase(fetchDevlogBatch.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
			})
			.addCase(fetchDevlogPage.pending, (state) => { state.loading = true; })
			.addCase(fetchDevlogPage.fulfilled, (state, action) => {
				state.loading = false;
				state.items = action.payload;
			})
			.addCase(fetchDevlogPage.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
			})
			.addCase(fetchDevlogBySlug.pending, (state) => { state.loading = true; })
			.addCase(fetchDevlogBySlug.fulfilled, (state, action) => {
				state.loading = false;
				state.devlog = action.payload;
			})
			.addCase(fetchDevlogBySlug.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			})
			.addCase(likeDevlog.fulfilled, (state, action) => {
				const { id, likes } = action.payload;
				state.items = state.items.map((d) =>
					d._id === id ? { ...d, likes } : d
				);
				if (state.devlog && state.devlog._id === id) {
					state.devlog.likes = likes;
				}
				if (state.editingDevlog && state.editingDevlog._id === id) {
					state.editingDevlog.likes = likes;
				}
			})
	},
});

export const { resetDevlogs,resetSingleDevlog } = devlogSlice.actions;
export default devlogSlice.reducer;